import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// Configurazione locale italiana per react-datepicker
import { registerLocale, setDefaultLocale } from "react-datepicker";
import it from "date-fns/locale/it";
registerLocale("it", it);
setDefaultLocale("it");

// Stile CSS per z-index alto sul calendario
const datePickerStyles = `
  .react-datepicker-popper {
    z-index: 9999 !important;
  }
`;

export default function DatePickerInner(props) {
  const [startDate, setStartDate] = React.useState(new Date());
  const ExampleCustomInput = ({ value, onClick }) => (
    <div
      style={{
        width: "300px",
        height: "40px",
        border: "1px solid black",
        lineHeight: "40px",
        paddingLeft: "10px",
        background: "#ffffff",
      }}
      onClick={onClick}
    >
      {value}
    </div>
  );

  return (
    <>
      <style>{datePickerStyles}</style>
      <DatePicker
        selected={props.selected != undefined ? props.selected : startDate}
        timeIntervals={15}
        dateFormat={props.dateFormat || "dd-MM-yyyy"}
        locale="it"
        calendarStartDay={1}
        readOnly={props.readOnly ? props.readOnly : false}
        onChange={(date) => {
          setStartDate(date);
          props.onChange(date);
        }}
        customInput={<ExampleCustomInput />}
        popperPlacement="bottom-start"
      />
    </>
  );
}
